// extracted by mini-css-extract-plugin
module.exports = {"content":"banner-module--content--MJqjm"};